// MUI Imports
import type { StepIconProps } from '@mui/material/StepIcon';

// Third-party Imports
import classnames from 'classnames';

import { DsIcon } from '../../../components/icons/DsIcon';
// Style Imports
import styles from './styles.module.css';

const StepperCustomDot = (props: StepIconProps) => {
  // Props
  const { active, completed, error } = props;

  if (error) {
    return <DsIcon icon="ALERT_TRIANGLE" size="xl" color="error.main" />;
  }
  if (completed) {
    return (
      <div
        className={classnames(styles.stepperCustomDot, 'flex items-center justify-center', {
          [styles.completedStepperCustomDot]: completed,
        })}
      >
        <DsIcon icon="CHECK" size="sm" sx={{ color: 'white' }} />
      </div>
    );
  }
  return <div className={classnames(styles.stepperCustomDot, { [styles.activeStepperCustomDot]: active })} />;
};

export default StepperCustomDot;
